module.exports = __webpack_public_path__ + "static/media/clean4.71649868.jpg";